import { Box, Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';
import AddressEntity from 'ui/shared/entities/address/AddressEntity';
import IconSvg from 'ui/shared/IconSvg';

import UserWalletAutoConnectAlert from '../UserWalletAutoConnectAlert';

interface Props {
  address: string;
  domain?: string;
  isAutoConnectDisabled?: boolean;
  isReconnecting?: boolean;
  onDisconnect: () => void;
}

const UserWalletMenuContent = ({ isAutoConnectDisabled, address, domain, isReconnecting, onDisconnect }: Props) => {
  const { t } = useI18n();
  const titleColor = useColorModeValue('#000000', 'white');
  const descColor = useColorModeValue('#616161', 'gray.100');
  const disconnectBg = useColorModeValue('#F0F0F0', 'white');
  const disconnectColor = useColorModeValue('#000000', 'black');

  return (
    <Box>
      { isAutoConnectDisabled && <UserWalletAutoConnectAlert/> }
      <Text fontSize="16px" fontWeight={ 700 } mb={ 1 } color={ titleColor }>{ t('user.myWallet') }</Text>
      <Text fontSize="14" mb={ 5 } fontWeight={ 400 } color={ descColor }>
        { t('user.yourWalletIsUsedToInteractWithAppsAndContracts') }
      </Text>
      <Flex alignItems="center" columnGap={ 2 } justifyContent="space-between">
        <AddressEntity
          address={{ hash: address, ens_domain_name: domain }}
          isTooltipDisabled
          truncation="dynamic"
          fontSize="sm"
          fontWeight={ 700 }
          noIcon
        />
        { isReconnecting ? <Spinner size="sm" m="2px" flexShrink={ 0 }/> : null }
      </Flex>
      <Flex onClick={ onDisconnect } mt={ 6 } sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '36px',
        borderRadius: '8px',
        bgColor: disconnectBg,
        cursor: 'pointer',
        gap: '4px',
      }}>
        <IconSvg name="sign_out" boxSize={ 5 }/>
        <Text sx={{
          color: disconnectColor,
          fontSize: '14px',
        }}>{ t('common.disconnect') }</Text>
      </Flex>
    </Box>
  );
};

export default React.memo(UserWalletMenuContent);
